module.exports = __webpack_public_path__ + "static/media/bruce_keiran.de2a4694.jpg";